function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-2610.000000, -1236.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(2610.000000, 1236.000000)"
}, React.createElement("path", {
  d: "M16.1,0 L4.8,15.5 L0,38.3 L16.1,48 L32.2,38.3 L27.4,15.4 L16.1,0 Z M7.4,15.9 L16.1,4 L24.8,15.9 L16.1,42 L7.4,15.9 Z M26,19.8 L29.6,37.2 L17.8,44.3 L26,19.8 Z M2.6,37.2 L6.2,19.8 L14.4,44.3 L2.6,37.2 Z",
  id: "Shape"
})));

var SvgEosLogo = function SvgEosLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 42 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEosLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eos-logo.1c39975a.svg";
export { ForwardRef as ReactComponent };